import useVuelidate from '@vuelidate/core';
import { required, requiredIf } from '@vuelidate/validators'
import SingleFileupload from '@ebg/vue-common/src/components/common/fileupload/single/SingleFileupload.vue'
import SnipeAssetUserAssets from '@/components/snipeasset/user/assets/SnipeAssetUserAssets.vue'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import D365AddressPicker from '@ebg/vue-common/src/components/d365/addresspicker/D365AddressPicker.vue'
import UserJobs from '@/components/user/tab/jobs/list/UserJobs.vue';
import UserEducation from '@/components/user/tab/education/list/UserEducation.vue';
import UserQualifications from '@/components/user/tab/qualifications/list/UserQualifications.vue';
import UserBills from '@/components/user/tab/bills/list/UserBills.vue';
import UserWorkSecurity from '@/components/user/tab/workSecurity/list/UserWorkSecurity.vue';
import UserContactPersons from '@/components/user/tab/contactPersons/list/UserContactPersons.vue';
import UserBaseAdGroups from '@/components/user/tab/baseAdGroups/list/UserBaseAdGroups.vue';
import UserInventory from '@/components/user/tab/inventory/list/UserInventory.vue';
import UserDocuments from '@/components/user/tab/documents/list/UserDocuments.vue';
import UserHistory from '@/components/user/tab/history/UserHistory.vue';
import InstructionsList from '@/components/moodle/instructions/InstructionsList.vue';
import ScheduleaAvailability from '@/components/ezuro/schedule/user/availability/List.vue';
import OnboardingChecklist from '@/components/user/onboarding/checklist/OnboardingChecklist.vue';
import { mapState } from 'vuex';
import Offboarding from '@/components/user/offboarding/Offboarding.vue';

export default {
  components: {
    SingleFileupload,
    SnipeAssetUserAssets,
    VueSimpleSuggest,
    D365AddressPicker,
    UserJobs,
    UserEducation,
    UserQualifications,
    UserBills,
    UserWorkSecurity,
    UserContactPersons,
    UserBaseAdGroups,
    UserInventory,
    UserDocuments,
    UserHistory,
    InstructionsList,
    ScheduleaAvailability,
    OnboardingChecklist,
    Offboarding
  },

  name: 'userEdit',

  data () {
    return {
      form: {
        id: null,
        name: null,
        surname: null,
        personalCode: '',
        userType: null,
        company_id: null,
        isMatchesDeclaredAddr: true,
        addressDeclared: {
          hasvzdCode: null,
          id: null,
          manualEntry: false,
          text: ''
        },
        actualAddress: {
          hasvzdCode: null,
          id: null,
          manualEntry: false,
          text: ''
        },
        gender: null,
        photo: null,
        ldapUsername: null,
        ldap_home_phone: null,
        emailHome: null,
        isAgreesPhoto: true,
        ldap_telephone_number: null,
        isUsePrivatePhone: false,
        isUsePrivatEemail: false,
        email: null,
        isAgreesBirthday: true,
        isUseForeigner: false,
        isAgreesPhone: false,
        showJobPositionForm: false,
        showOvpButton: false,
        showSendNoShowButton: false,
        showOvpComment: false,
        ovpComment: null,
        showStartDate: false,
        job_position: {
          department_id: null,
          division_id: null,
          job_position_id: null
        }
      },
      isLoading: false,
      api_id: '',
      usernameReq: null,
      generatingUsername: false,
      activeTab: 'UserJobs',
      D365AddressPickerStyleSize: '',
      colNumber: 6,
      showOnly: null
    }
  },

  validations: {
    form: {
      name: { required },
      surname: { required },
      company_id: { required },
      personalCode: {
        validatePersonalCode: function (value, vm) {
          if (vm.userType !== null &&
            this.$store.getters.getParamFromConfig('contact_person_types', vm.userType, 'code', this.$i18n.locale) === 'CHILD' &&
            !vm.isUseForeigner &&
            value.length < 11
          ) {
            return false;
          }
          return true;
        }
      },
      addressDeclared: {
        text: {
          validateAddressDeclared: function (value, vm) {
            if ((vm.manualEntry && value !== '') || (!vm.manualEntry && vm.id !== null)) {
              return true;
            }
            return false;
          }
        }
      },
      actualAddress: {
        text: {
          validateAddressDeclared: function (value, vm) {
            if (!this.form.isMatchesDeclaredAddr && ((vm.manualEntry && value === '') || (!vm.manualEntry && vm.id === null))) {
              return false;
            }
            return true;
          }
        }
      },
      gender: { required },
      userType: { required },
      ldap_home_phone: {
        required: requiredIf(function () {
          return this.form.isUsePrivatePhone;
        })
      },
      emailHome: {
        required: requiredIf(function () {
          return this.form.isUsePrivatEemail;
        })
      }
    }
  },

  computed: {
    ...mapState(['config']),
    jobWorkspaceTypes () {
      return this.$store.getters.getConfigOptions('job_workspace_types');
    },
    departmentOptions () {
      const departments = this.$store.getters.getConfigOptions(
        'company_departments',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id']
      ).filter(
        el => parseInt(el.company_id) === parseInt(this.form.company_id)
      );

      return this.BasicHelper.sortArrayByKeyValue(departments, 'sortText');
    },
    divisionOptions () {
      const division = this.$store.getters.getConfigOptions(
        'company_divisions',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id', 'department_id']
      ).filter(
        el => (
          parseInt(el.company_id) === parseInt(this.form.company_id) &&
          (this.form.job_position.department_id === null || parseInt(el.department_id) === parseInt(this.form.job_position.department_id))
        )
      );

      return this.BasicHelper.sortArrayByKeyValue(division, 'sortText');
    },
    jobPositionOptions () {
      const options = [];
      const companyJobs = this.$store.getters.getConfigOptions(
        'company_jobs',
        this.$i18n.locale,
        null, null, false, false, false,
        ['name', 'workspace_type_id', 'job_positions']
      );
      if (companyJobs && this.form.company_id) {
        Object.values(companyJobs).forEach(el => {
          Object.values(el.job_positions).forEach(jobPos => {
            if (
              parseInt(jobPos.company_id) === parseInt(this.form.company_id) &&
              (this.form.job_position.department_id === null || parseInt(jobPos.department_id) === parseInt(this.form.job_position.department_id)) &&
              (this.form.job_position.division_id === null || parseInt(jobPos.division_id) === parseInt(this.form.job_position.division_id))
            ) {
              options.push({ value: jobPos.id, text: el.name[this.$i18n.locale], department_id: jobPos.department_id, workspace_type_id: el.workspace_type_id })
            }
          });
        });
      }
      return this.BasicHelper.sortArrayByKeyValue(options, 'text');
    },
    tabOptions () {
      const options = [];
      if (this.canShowJobs) {
        options.push({ code: 'UserJobs', text: this.$t('user.tab.jobs'), slotcode: 'UserJobs' });
      }
      if (this.canShowEducation) {
        options.push({ code: 'UserEducation', text: this.$t('user.tab.education'), slotcode: 'UserEducation' });
      }
      if (this.canShowQualification) {
        options.push({ code: 'UserQualifications', text: this.$t('user.tab.qualifications'), slotcode: 'UserQualifications' });
      }
      if (this.canShowWorkSecurity) {
        // options.push({ code: 'UserWorkSecurity', text: this.$t('user.tab.work-security'), slotcode: 'UserWorkSecurity' });
      }
      if (this.canShowContactPerson) {
        options.push({ code: 'UserContactPersons', text: this.$t('user.tab.contact-persons'), slotcode: 'UserContactPersons' });
      }
      if (this.canShowUserSnipeAssets) {
        options.push({ code: 'SnipeAssetUserAssets', text: this.$t('user.tab.inventory'), slotcode: 'SnipeAssetUserAssets' });
      }
      if (this.canShowUserHistory) {
        options.push({ code: 'UserHistory', text: this.$t('user.tab.history'), slotcode: 'UserHistory' });
      }
      if (this.ApiRequest.userHasPermission('beta-tester-access')) {
        options.push({ code: 'InstructionsList', text: this.$t('user.tab.instructions'), slotcode: 'InstructionsList', params: { provideUserId: true, showMoodleLink: false } });
      }
      if (this.canShowUserAvailability) {
        options.push({ code: 'ScheduleaAvailability', text: this.$t('user.tab.avalabilty'), slotcode: 'ScheduleaAvailability' });
      }
      if (this.canShowOnboardingChecklist) {
        options.push({ code: 'OnboardingChecklist', text: this.$t('user.tab.onboarding'), slotcode: 'OnboardingChecklist' });
      }
      if (this.canShowOffboardingChecklist) {
        options.push({ code: 'Offboarding', text: this.$t('user.tab.offboarding'), slotcode: 'Offboarding' });
      }

      return options;
    },

    userTypeOptions () {
      return this.$store.getters.getConfigOptions('user_types', this.$i18n.locale);
    },

    genderOptions () {
      return this.$store.getters.getConfigOptions('user_gender', this.$i18n.locale);
    },

    companyOptions () {
      return this.BasicHelper.sortArrayByKeyValue(
        this.$store.getters.getConfigOptions('user_companies', this.$i18n.locale, 'disabled', '0')
      );
    },

    isNewRecord () {
      return (this.canEdit && this.api_id === 'NEW');
    },

    canShowUserAvailability () {
      return true;
    },
    canShowOnboardingChecklist () {
      return this.ApiRequest.userHasPermission('view-user-onboarding');
    },
    canShowOffboardingChecklist () {
      return this.ApiRequest.userHasPermission('view-user-offboarding');
    },
    canShowUserHistory () {
      return this.ApiRequest.userHasPermission('view-user-history');
    },

    canShowUserSnipeAssets () {
      return this.ApiRequest.userHasPermission('view-user-snipe-assets');
    },

    canShowContactPerson () {
      return this.ApiRequest.userHasPermission('view-contact-person');
    },

    canShowWorkSecurity () {
      return this.ApiRequest.userHasPermission('view-work-security');
    },

    canShowQualification () {
      return this.ApiRequest.userHasPermission('view-qualification');
    },

    canShowEducation () {
      return this.ApiRequest.userHasPermission('view-education');
    },

    canShowJobs () {
      return this.ApiRequest.userHasPermission('view-job');
    },

    canEdit () {
      return this.ApiRequest.userHasPermission('edit-all-users') && !this.isLoading;
    },

    canSave () {
      return (this.ApiRequest.userHasPermission('save-all-users'));
    },

    isUserType () {
      if (
        this.form.userType !== null &&
        this.$store.getters.getParamFromConfig('contact_person_types', this.form.userType, 'code', this.$i18n.locale) === 'HUSBAND'
      ) {
        return true;
      }
      return false;
    },

    isRequiredPersonalCode () {
      if (
        this.form.userType !== null &&
        this.$store.getters.getParamFromConfig('contact_person_types', this.form.userType, 'code', this.$i18n.locale) === 'CHILD' &&
        !this.form.isUseForeigner
      ) {
        return true;
      }
      return false;
    }
  },

  methods: {
    setActiveTabFromHash () {
      const hashParam = this.$route.hash.replace('#', '');
      if (hashParam && this.tabOptions.some(o => o.code === hashParam)) {
        this.activeTab = hashParam;
      }
    },
    sendNoShow () {
      this.isLoading = true;
      this.ApiRequest.request(`user/send-noshow/${this.api_id}`, this.ApiRequest.REQUEST_PATCH, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          if (response.data?.send_noshow && response.data.send_noshow === true) {
            this.form.showSendNoShowButton = false;
            this.$store.commit('toastAdd', {
              context: 'success',
              message: this.$t('user.edit.send-noshow-success')
            });
          }
        }
        this.isLoading = false;
      });
    },
    async show () {
      this.api_id = this.$route.params.api_id;
      if (this.api_id !== 'NEW') {
        const path = `user/show/${this.api_id}`;
        const { data } = await this.loadData(path);
        if (data.show_only) {
          this.showOnly = data.show_only;
        } else {
          this.showOnly = false;
        }
        this.BasicHelper.syncObjectValuesByKeys(this.form, data);
        this.changeMatchesDeclaredAddr(this.form.isMatchesDeclaredAddr);
      } else {
        this.form.userType = this.$store.getters.getParamFromConfigByFilter('user_types', 'code', 'EMPLOYEE', 'id');
      }
    },

    tabChanged (el) {
      if (this.tabOptions[el]) {
        this.activeTab = this.tabOptions[el].code;
        if (this.$route.hash !== `#${this.activeTab}`) {
          this.$router.replace({ hash: this.activeTab });
        }
      }
    },

    isPersonCode (el) {
      if (!this.form.isUseForeigner) {
        const keyCode = (el.keyCode ? el.keyCode : el.which);
        if (keyCode == 45 || (keyCode >= 48 && keyCode <= 57)) {
          return true;
        }
        return el.preventDefault();
      }
      return true;
    },

    async loadData (path) {
      try {
        return new Promise((resolve, reject) => {
          this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, [], response => {
            if (response.error) {
              this.isLoading = false;
              this.ApiRequest.displayErrorDialog(response, this);
              reject(response.error);
            }
            if (response.data.last_change) {
              const code = response.data.last_change.change_type?.code;
              const isUsed = response.data.last_change.is_used;
              if (['CREATED', 'IS_DISABLED_0', 'COMPANY_CHANGED'].includes(code) && !isUsed) {
                this.form.showJobPositionForm = true;
              }
              if (['CREATED', 'IS_DISABLED_0', 'COMPANY_CHANGED', 'JOB_POSITION_CREATED'].includes(code) && !isUsed) {
                this.form.showOvpButton = true;
              }
            }
            if (response.data.last_job_position?.position_onboarding_events.some(event => event.event_type === 'send_ovp')) {
              this.form.showOvpButton = false;
            }

            this.form.showSendNoShowButton = response.data.last_job_position_show_send_noshow_button;

            if (!response.data.last_job_position) {
              this.form.showJobPositionForm = true;
              this.form.showOvpButton = true;
            }
            if (response.data.potential_job_position_exists === true) {
              this.form.showStartDate = true;
              this.form.job_position.date_start = response.data.last_job_position?.planned_start_date;
            }
            resolve(response);
          });
        });
      } catch (e) {
        console.error(e);
      }
    },

    async submitForm () {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      const reqData = this.BasicHelper.cloneObject(this.form);
      reqData.files = (this.form.photo ? [this.form.photo] : []);
      const formData = this.ApiRequest.createFormData(reqData, Object.keys(reqData), 'user', this, false);
      this.isLoading = true;
      const { data } = await this.save(`user/save/${this.api_id}`, formData);
      if (data) {
        if (data.name && data.surname) {
          this.form.name = data.name;
          this.form.surname = data.surname;
        }
        let msg = ''
        if (this.api_id === 'NEW') {
          msg = this.$t('user.msg.add-successfully', { name: data.name, surname: data.surname });
          this.showOnly = false;
        } else {
          msg = this.$t('user.msg.update-successfully', { name: data.name, surname: data.surname });
        }

        if (data.job_position_added) {
          this.$store.commit('toastAdd', { context: 'success', message: 'Amats pievienots' });
          this.form.showOvpButton = true;
        }

        if (data.sent_mails) {
          let message = 'Nosūtīti e-pasti ';
          message = message + data.sent_mails.join(', ');
          this.$store.commit('toastAdd', { context: 'success', message: message });
        }

        this.$store.commit('toastAdd', { context: 'success', message: msg });
        if (this.api_id === 'NEW') {
          this.api_id = data.api_id;
          this.$router.push({ name: 'menu.user.view', params: { api_id: data.api_id } });
        }
      }
      this.isLoading = false;
    },

    close () {
      this.$router.push({ name: 'menu.user.list' });
    },

    changedDeclaredAddress (el) {
      this.form.addressDeclared = el;
    },

    changedActualAddress (el) {
      this.form.actualAddress = el;
    },

    changeMatchesDeclaredAddr (el) {
      if (el) {
        this.D365AddressPickerStyleSize = '';
        this.colNumber = 6;
      } else {
        this.D365AddressPickerStyleSize = 'max-width: 50px;';
        this.colNumber = 3;
      }
    },
    companyChange () {
      this.updateLdapEmail();
      this.form.showJobPositionForm = true;
    },
    updateLdapEmail () {
      if (this.api_id !== 'NEW') {
        return;
      }
      this.form.email = this.form.ldapUsername;
    },

    getLdapUsername () {
      if (this.api_id !== 'NEW') {
        return;
      }

      if (this.usernameReq) {
        this.usernameReq.cancel('changed search query');
      }

      this.generatingUsername = true;
      const reqData = { name: this.form.name, surname: this.form.surname };
      const self = this;
      setTimeout(
        function () {
          if (reqData.name === self.form.name && reqData.surname === self.form.surname) {
            self.usernameReq = self.ApiRequest.request('user/generate-ldap-username', self.ApiRequest.REQUEST_POST, reqData, function (response) {
              if (response.data) {
                self.form.ldapUsername = response.data;
                self.form.email = response.data;
                self.generatingUsername = false;
              } else if (response.error) {
                self.generatingUsername = false;
                self.ApiRequest.displayErrorDialog(response, self);
              }
            });
          }
        }, 500);
    },

    async save (path, formData) {
      try {
        return new Promise((resolve, reject) => {
          this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, formData, response => {
            if (response.error) {
              this.isLoading = false;
              this.ApiRequest.displayErrorDialog(response, this);
              reject(response.error);
              return;
            }
            this.form.showSendNoShowButton = response.data.last_job_position_show_send_noshow_button;
            resolve(response);
          });
        });
      } catch (e) {
        console.error(e);
      }
    },
    async populateJobPosition (el) {
      this.form.directManager = null;
      if (el !== null) {
        this.form.job_position.department_id = el.department_id;
        this.form.job_position.directManager = this.$store.getters.getDirectManager(el, this.form.user_id, this.form.division_id);
      }
    },
    toggleOvpComment () {
      this.form.showOvpComment = !this.form.showOvpComment;
    },
    async sendOVP () {
      this.v$.$touch();
      if (this.v$.$invalid || !this.api_id) {
        return;
      }
      if (this.form.showJobPositionForm && (!this.form.job_position.department_id || !this.form.job_position.job_position_id)) {
        this.$store.commit('toastAdd', { context: 'danger', message: this.$t('user.edit.send-mail-validation-error') });
        return;
      }
      await this.submitForm();
      this.isLoading = true;
      const reqData = {
        ovp_comment: this.form.ovpComment
      };
      this.ApiRequest.request(`user/send-ovp/${this.api_id}`, this.ApiRequest.REQUEST_PATCH, reqData, (response) => {
        if (response.error) {
          this.isLoading = false;
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.isLoading = false;
          if (response.data?.sent_ovp && response.data.sent_ovp === true) {
            this.form.showOvpButton = false;
            this.$store.commit('toastAdd', {
              context: 'success',
              message: this.$t('user.edit.send-ovp-success')
            });
          }
          if (response.data?.checklist_generated && response.data.checklist_generated === true) {
            this.$store.commit('toastAdd', {
              context: 'success',
              message: this.$t('user.edit.checklist-generated-success')
            });
          }
        }
      });
    }
  },

  watch: {
    tabOptions: {
      immediate: true,
      handler (val) {
        if (val.length > 0) {
          this.activeTab = val[0].code;
        }
      }
    },

    '$route.hash' (newHash, oldHash) {
      if (newHash !== oldHash) {
        this.setActiveTabFromHash();
      }
    },

    '$route.params.api_id' () {
      this.setActiveTabFromHash();
    }
  },

  created () {
    this.setActiveTabFromHash();
  },

  mounted () {
    if (this.$route.params.api_id) {
      this.show().then(() => null);
    }
    if (this.$route.params.api_id === 'NEW') {
      this.form.showJobPositionForm = true;
    }
  },

  setup () {
    return { v$: useVuelidate({ $stopPropagation: true, $scope: 'userEdit' }) }
  }
}
